import { useQuery } from '@apollo/react-hooks'

import { AcceptanceDocument, Signature } from 'generated/types'

import CardOrderReview from './gql/card-order-review-query.gql'

type CardOrderReviewQuery = {
  signatures: Signature[]
  allAcceptanceDocuments: AcceptanceDocument[]
  bankAccountDisclosures: AcceptanceDocument[]
}

// AcceptanceDocument type
// Needs to match with the `type` value coming from the BE
const PROGRAM_AGREEMENT_DOC_TYPE = 'program_agreement'
const ESIGN_CONSENT_DOC_TYPE = 'spend_esign_consent_nbkc'

const findProgramAgreementDoc = (docs: AcceptanceDocument[] = []) =>
  docs.filter(doc => doc.type == PROGRAM_AGREEMENT_DOC_TYPE)

const findEsignDocUrl = (bankDocs: AcceptanceDocument[] = []): string | undefined => {
  return bankDocs.find(bankDoc => bankDoc.type === ESIGN_CONSENT_DOC_TYPE)?.url
}

export const useCardOrderReviewData = () => {
  const { data, loading } = useQuery<CardOrderReviewQuery>(CardOrderReview, {
    fetchPolicy: 'network-only',
  })

  const signatures = data?.signatures || []
  const signatureSvg = signatures[signatures.length - 1]?.svgFile

  const programAgreementDoc = findProgramAgreementDoc(data?.allAcceptanceDocuments)
  const bankAccountDisclosures = data?.bankAccountDisclosures || []
  const acceptanceDocuments = [...programAgreementDoc, ...bankAccountDisclosures]

  return {
    loading,
    signatureSvg,
    acceptanceDocuments,
    eSignUrl: findEsignDocUrl(acceptanceDocuments),
  }
}
